import React from "react";
import {MyHouseholdMembersCardsApp} from "../../Functionality/MyHouseholdMembersCardsApp";
import NotInformation from "../../../../components/NotInformation";
import SearchSimple from "../../../../components/SearchSimples/SearchSimple";
import ResidentAssignedCard from "../../../Building/SubComponents/Residents/ResidentAssignedCard";
import CopyBuildingLinkModal from "../../../Building/Modal/CopyBuildingLinkModal";

/**
 * @Author: karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer
 * @Email : kpozos@ibl.mx
 *
 * Household members of my building detail, searchable card grid with the
 * actions menu of each member.
 *
 * @param {Object} props
 * @param {Object} props.buildingDetail - Building of the logged resident, the members are searched
 *   with its apartment and the registration link is built with it.
 * @param {Function} props.onCreateMember - Opens the add household member modal, the empty state calls it too.
 * @param {boolean} props.modified - Flag raised by the add member modal so the list is reloaded.
 * @param {Function} props.setModified - Lowers the flag once the list is loaded again.
 */
const MyHouseholdMembersCards = ({ buildingDetail, onCreateMember, modified, setModified }) => {
    const {
        t,
        option,
        searchElement,
        setSearchElement,
        results,
        setResults,
        rowsPerPage,
        setSearch,
        setSimpleSearch,
        handleSearch,
        handleResetSearch,
        invitationLinkModal,
        setInvitationLinkModal,
        selectedItem,
        setSelectedItem,
        getActionsButtons,
        pagination,
        elementRef
    } = MyHouseholdMembersCardsApp({
        buildingApartmentId: buildingDetail?.buildingApartmentId,
        modified,
        setModified
    });

    return (
        <>
            <div className="row my-4 flex-shrink-0">
                <div className={"col-12 px-0"}>
                    <SearchSimple
                        id={"txt_hhm_search_simple"}
                        label={'search_by_name_or_email'}
                        searchElement={searchElement}
                        setSearchElement={setSearchElement}
                        optionTable={option}
                        rowsPerPage={rowsPerPage}
                        setSearchResults={setResults}
                        setSearch={setSearch}
                        setSimpleSearch={setSimpleSearch}
                        callApi={handleSearch}
                        resetApi={handleResetSearch}
                    />
                </div>
            </div>

            {results?.content?.length > 0 ? (
                <>
                    <div className="panelTables-container custom-scrollbar" ref={elementRef}>
                        <div className="row">
                            {
                                results.content.map((member, index) => (
                                    <div className='col-12 col-md-6 mb-3 px-1' key={member?.id}>
                                        <ResidentAssignedCard
                                            keyId={'id'}
                                            item={member}
                                            actions={getActionsButtons(member, index)}
                                        />
                                    </div>
                                ))
                            }
                        </div>
                    </div>

                    <div className={"flex-shrink-0"}>
                        {pagination()}
                    </div>
                </>)
                : (
                    /* The empty list offers the same action of the tab, a search
                       without results is not the place to register a member */
                    <NotInformation
                        text={searchElement === "" ? t('you_have_not_registered_any_household_member_yet') : t("no_results_found")}
                        card={true}
                        className={"h-100"}
                        showButton={searchElement === ""}
                        buttonId={'btn_hhm_add_member'}
                        buttonTrans={'add_member'}
                        buttonOnclick={onCreateMember}
                    />
            )}

            {invitationLinkModal && buildingDetail &&
                <CopyBuildingLinkModal
                    show={invitationLinkModal}
                    setShow={setInvitationLinkModal}
                    itemSelected={{
                        id: buildingDetail?.buildingId ?? buildingDetail?.id,
                        name: buildingDetail?.buildingName
                    }}
                    userSelected={selectedItem && {
                        userId: selectedItem?.userId,
                        name: selectedItem?.fullName,
                        apartment: buildingDetail?.apartmentName,
                        buildingApartmentId: selectedItem?.buildingApartmentId ?? buildingDetail?.buildingApartmentId
                    }}
                    setItemSelected={setSelectedItem}
                />
            }
        </>
    );
};

export default MyHouseholdMembersCards;
